module.exports = __webpack_public_path__ + "media/images/device-limit-icon-1041b33b85c11f1fad5f789b5efb3f8d.svg";